<template>
  <v-container fluid class="pa-0" fill-height>
    <v-app-bar app color="primary" dark extension-height="64">
      <v-row>
        <v-col cols="1" class="pt-5"> Profile: </v-col>
        <v-col cols="3">
          <v-select
            label=""
            :items="difficulties"
            v-model="filter.difficulty"
            hide-details
          />
        </v-col>
        <v-col cols="3">
          <strong>Days of wipe:</strong>
          <v-btn-toggle color="green" v-model="filter.daysOfWipe" multiple>
            <v-btn small v-for="day in days" :key="day">
              {{ day }}
            </v-btn>
          </v-btn-toggle>
        </v-col>
        <v-col cols="2">
          <v-btn @click="clearFilter()">Clear Filters</v-btn>
        </v-col>
      </v-row>
      <template v-slot:extension>
        <v-row>
          <v-col cols="4" class="py-0">
            <v-text-field
              prepend-icon="mdi-magnify"
              v-model="search"
              hide-details
            >
            </v-text-field>
          </v-col>
          <v-col cols="3" class="pt-5">
            <v-checkbox
              label="Hide Unused"
              v-model="filter.hideUnused"
              hide-details
            ></v-checkbox>
          </v-col>
        </v-row>
      </template>
    </v-app-bar>
    <v-layout>
      <div v-if="!filter.difficulty">Please select a profile</div>
      <div class="grid" v-if="filter.difficulty" style="background: #1e1e1e">
        <div
          v-for="item in itemsFiltered"
          v-if="!filter.hideUnused || inProfile(item)"
        >
          <div class="lootItem" :class="{ fade: !inProfile(item) }">
            <img
              :src="`https://endgame-images.s3-ap-southeast-2.amazonaws.com/rust-items/${item.shortname}.png`"
              :alt="item.name"
              :title="item.name"
            />
          </div>
          <v-btn @click="toggleItemState(item)" class="actionButton" icon dark>
            <v-icon v-if="inProfile(item)">mdi-close</v-icon>
            <v-icon v-else>mdi-plus</v-icon>
          </v-btn>

          <div class="amount" v-if="inProfile(item)">
            Min:
            <span
              contentEditable="true"
              style="display: inline-block; width: 100px"
              @mousedown="clickFocus"
              @keypress="keyPress"
              @focus="focusItem(item)"
              @input="onLootInput"
              class="lootEditMinValue"
              >{{ loot[`${filter.difficulty}Bases`][item.shortname].min }}</span
            >
            <br />
            Max:
            <span
              contentEditable="true"
              style="display: inline-block; width: 100px"
              @mousedown="clickFocus"
              @keypress="keyPress"
              @focus="focusItem(item)"
              @input="onLootInput"
              class="lootEditMaxValue"
              >{{ loot[`${filter.difficulty}Bases`][item.shortname].max }}</span
            >
          </div>
        </div>
      </div>
    </v-layout>
  </v-container>
</template>

<script>
  // import VueApexCharts from "vue-apexcharts";

  import { mapGetters } from "vuex";
  import AppBar from "@/components/AppBar";
  import moment from "moment";

  export default {
    components: { AppBar },
    computed: {
      ...mapGetters([
        "currentUser",
        "items",
        "itemsLoading",
        "lootLoading",
        "loot",
      ]),
      itemsFiltered() {
        let filteredItems = this.items;
        if (this.search !== "") {
          filteredItems = filteredItems.filter((b) => {
            return (
              b.shortname.toUpperCase().indexOf(this.search.toUpperCase()) > -1 ||
              b.name.toUpperCase().indexOf(this.search.toUpperCase()) > -1
            );
          });
        }

        return filteredItems;
      },
    },
    props: {
      source: String,
    },
    data: () => ({
      difficulties: ["Easy", "Medium", "Hard", "Expert", "Nightmare"],
      days: ["1", "2", "3", "4", "5"],
      searchInput: "",
      search: "",
      focusLootItem: null,
      toBeSaved: {},
      filter: {
        dayOfWipe: [],
        difficulty: "Easy",
        hideUnused: false,
      },
      saveDebouce: null,
      saveTimeout: 1000,
      saving: false,
    }),
    mounted() {
      this.$store.dispatch("loadLoot");
    },
    methods: {
      clickFocus(e) {
        e.preventDefault();
        e.target.focus();
        document.execCommand("selectAll", false, null);
        // document.getSelection().collapseToEnd();
      },
      focusItem(item) {
        this.focusLootItem = item;
        document.execCommand("selectAll", false, null);
        document.getSelection().collapseToEnd();
      },
      keyPress(e) {
        if (isNaN(e.key)) {
          e.preventDefault();
        }
      },
      onLootInput(e) {
        if (e.target.innerHTML === "") {
          e.target.innerHTML = 0;
          e.target.focus();
          document.execCommand("selectAll", false, null);
        }

        let item = {
          focusLootItem: JSON.parse(JSON.stringify(this.focusLootItem)),
          profile: JSON.parse(JSON.stringify(this.filter.difficulty + "Bases")),
        };

        if (this.toBeSaved.hasOwnProperty(item.focusLootItem.shortname)) {
          item = this.toBeSaved[item.focusLootItem.shortname];
        }

        if (e.target.className == "lootEditMinValue") {
          item["min"] = parseInt(e.target.innerHTML);
        } else if (e.target.className == "lootEditMaxValue") {
          item["max"] = parseInt(e.target.innerHTML);
        }

        this.toBeSaved[item.focusLootItem.shortname] = item;

        clearTimeout(this.saveDebouce);
        this.saveDebouce = setTimeout(() => {
          let localToBeSaved = JSON.parse(JSON.stringify(this.toBeSaved));
          this.toBeSaved = {};
          this.saveMultiple(Object.values(localToBeSaved));
        }, this.saveTimeout);
      },
      inProfile(item) {
        if (typeof this.loot[`${this.filter.difficulty}Bases`] == "undefined") {
          return false;
        }
        return this.loot[`${this.filter.difficulty}Bases`].hasOwnProperty(
          item.shortname
        );
      },
      clearFilter() {
        console.log(this.filter);
        this.filter.dayOfWipe = [];
        this.filter.difficulty = null;
        this.filter.autospawnEnabled = false;
      },
      onSearchChange() {
        clearTimeout(this.searchDebounce);
        this.searchDebounce = setTimeout(() => {
          this.page = 1;
          this.search = this.searchInput;
        }, 500);
        requestAnimationFrame(x);
      },
      saveMultiple(loot) {
        let toBeSaved = loot.length;
        let currentlySaved = 0;
        loot.forEach((item) => {
          let payload = {
            profile: item.profile,
            item_shortname: item.focusLootItem.shortname,
            daysOfWipe: 0,
          };

          if (item.hasOwnProperty("min")) {
            payload["min"] = item.min;
          }
          if (item.hasOwnProperty("max")) {
            payload["max"] = item.max;
          }

          this.saving = true;
          this.$store.dispatch("saveLoot", payload).then((res) => {
            this.saving = false;

            currentlySaved += 1;
            console.log(currentlySaved);
            console.log(toBeSaved);

            if (toBeSaved == currentlySaved) {
              this.$swal({
                title: "Success!",
                text: `Automatically Saved`,
                type: "success",
                position: "top-end",
                toast: true,
                showConfirmButton: false,
                timer: 1500,
                timerProgressBar: true,
              });
              this.$store.dispatch("loadBases");
            }
          });
        });
      },
      toggleItemState(item) {
        if (this.inProfile(item)) {
          this.removeItem(item);
        } else {
          this.addItem(item);
        }
      },
      removeItem(item) {
        let payload = {
          profile: this.filter.difficulty + "Bases",
          item_shortname: item.shortname,
        };
        this.$store.dispatch("removeLoot", payload).then((res) => {
          if (res.data.Result == "Success") {
            this.$swal({
              title: "Success!",
              text: `${item.name} was removed to the ${payload.profile} Profile`,
              type: "success",
              position: "top-end",
              toast: true,
              showConfirmButton: false,
              timer: 2000,
              timerProgressBar: true,
            });
          }
        });
      },
      addItem(item) {
        let payload = {
          profile: this.filter.difficulty + "Bases",
          item_shortname: item.shortname,
          max: 1,
          min: 1,
          daysOfWipe: 0,
        };
        this.$store.dispatch("addLoot", payload).then((res) => {
          if (res.data.Result == "Success") {
            this.$swal({
              title: "Success!",
              text: `${item.name} was added to the ${payload.profile} Profile`,
              type: "success",
              position: "top-end",
              toast: true,
              showConfirmButton: false,
              timer: 2000,
              timerProgressBar: true,
            });
          }
        });
      },
    },
  };
</script>

<style scoped>
  .v-main__wrap {
    background: #1e1e1e;
  }

  .grid {
    width: 100%;
    background: #1e1e1e;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
    grid-template-rows: auto auto 1fr 1fr 1fr auto auto;
    grid-gap: 1rem;
  }

  .grid > div {
    /*background: black;*/
    padding: 1rem;
    position: relative;
  }

  .grid > div::before {
    content: "";
    display: block;
    padding-bottom: 100%;
  }

  .grid > div img {
    position: absolute;
    max-width: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .grid > div .lootItem {
    cursor: pointer;
  }

  .amount {
    color: white;
    background: rgba(0, 0, 0, 0.2);
    z-index: 1;
    display: block;
    position: relative;
    width: calc(100% + 2rem);
    margin-left: -1rem;
    margin-right: -1rem;
    text-align: center;
  }

  .fade {
    opacity: 0.1;
  }

  .actionButton {
    position: absolute;
    top: 5px;
    right: 0;
  }
</style>
